export default {"src":"https://static.eleduck.com/_next/static/media/other.a019d641.svg","height":26,"width":14,"blurWidth":0,"blurHeight":0};